import { FC } from 'react';
import { SidebarPanel, SlidesList, SlideThumbnail, ThumbnailContent, SlideNumberWrapper, SlideNumber } from '../styles/PresentationModeModal.styles';
import { CoverSlide } from './CoverSlide';
import { LongreadBlockRenderer } from './LongreadBlockRenderer';

interface SidebarProps {
  isOpen: boolean;
  backgroundColor?: string;
  totalSlides: number;
  currentSlide: number;
  project?: any;
  blocks?: any[];
  presentationBlocks: any[];
  theme: any;
  lang: string;
  onSlideClick: (e: React.MouseEvent, slideIndex: number) => void;
}

export const Sidebar: FC<SidebarProps> = ({
  isOpen,
  backgroundColor,
  totalSlides,
  currentSlide,
  project,
  blocks,
  presentationBlocks,
  theme,
  lang,
  onSlideClick,
}) => {
  const SlideThumbnailContent: FC<{ slideIndex: number }> = ({ slideIndex }) => {
    if (slideIndex === 0) {
      return (
        <ThumbnailContent>
          <CoverSlide project={project} blocks={blocks} backgroundColor={backgroundColor} lang={lang} />
        </ThumbnailContent>
      );
    } else {
      const blockIndex = slideIndex - 1;
      const block = presentationBlocks[blockIndex];
      if (!block) return null;

      return (
        <ThumbnailContent>
          <LongreadBlockRenderer block={block} theme={theme} backgroundColor={backgroundColor} />
        </ThumbnailContent>
      );
    }
  };

  if (!isOpen) return null;

  return (
    <SidebarPanel isOpen={isOpen} backgroundColor={backgroundColor}>
      <SlidesList>
        {Array.from({ length: totalSlides }).map((_, index) => (
          <SlideThumbnail
            key={index}
            isActive={currentSlide === index}
            onClick={(e) => onSlideClick(e, index)}
          >
            <SlideThumbnailContent slideIndex={index} />
            {currentSlide === index && (
              <SlideNumberWrapper>
                <SlideNumber>{index + 1}</SlideNumber>
              </SlideNumberWrapper>
            )}
          </SlideThumbnail>
        ))}
      </SlidesList>
    </SidebarPanel>
  );
};
import { FC } from 'react';
import { SidebarPanel, SlidesList, SlideThumbnail, ThumbnailContent, SlideNumberWrapper, SlideNumber } from '../styles/PresentationModeModal.styles';
import { CoverSlide } from './CoverSlide';
import { LongreadBlockRenderer } from './LongreadBlockRenderer';

interface SidebarProps {
  isOpen: boolean;
  backgroundColor?: string;
  totalSlides: number;
  currentSlide: number;
  project?: any;
  blocks?: any[];
  presentationBlocks: any[];
  theme: any;
  lang: string;
  onSlideClick: (e: React.MouseEvent, slideIndex: number) => void;
}

export const Sidebar: FC<SidebarProps> = ({
  isOpen,
  backgroundColor,
  totalSlides,
  currentSlide,
  project,
  blocks,
  presentationBlocks,
  theme,
  lang,
  onSlideClick,
}) => {
  const SlideThumbnailContent: FC<{ slideIndex: number }> = ({ slideIndex }) => {
    if (slideIndex === 0) {
      return (
        <ThumbnailContent>
          <CoverSlide project={project} blocks={blocks} backgroundColor={backgroundColor} lang={lang} />
        </ThumbnailContent>
      );
    } else {
      const blockIndex = slideIndex - 1;
      const block = presentationBlocks[blockIndex];
      if (!block) return null;

      return (
        <ThumbnailContent>
          <LongreadBlockRenderer block={block} theme={theme} backgroundColor={backgroundColor} />
        </ThumbnailContent>
      );
    }
  };

  if (!isOpen) return null;

  return (
    <SidebarPanel isOpen={isOpen} backgroundColor={backgroundColor}>
      <SlidesList>
        {Array.from({ length: totalSlides }).map((_, index) => (
          <SlideThumbnail
            key={index}
            isActive={currentSlide === index}
            onClick={(e) => onSlideClick(e, index)}
          >
            <SlideThumbnailContent slideIndex={index} />
            {currentSlide === index && (
              <SlideNumberWrapper>
                <SlideNumber>{index + 1}</SlideNumber>
              </SlideNumberWrapper>
            )}
          </SlideThumbnail>
        ))}
      </SlidesList>
    </SidebarPanel>
  );
};
